import React, { Component } from "react";
import { ErrorCode } from "../../../const";
import Alert from "sweetalert-react";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";
import Loading from "../../../components/Loading";
import {
  ProgressBar,
  MenuItem,
  DropdownButton,
  FormGroup,
  FormControl,
  InputGroup,
  Button,
  Table,
  ControlLabel,
} from "react-bootstrap";

const dicSingleConsol = {
  single: "SINGLE",
  consol: "CONSOL",
};

const dicScenario = {
  lowest_car: "CAR thấp nhất",
  lowest_lev: "LEV thấp nhất",
  s1: "S1",
  s2: "S2",
  s3: "S3",
  s4: "S4",
  s5: "S5",
  s6: "S6",
  s7: "S7",
  s8: "S8",
};

class FileInfo extends Component {
  constructor(props) {
    super(props);
    const fileInfo = props.location.state || {};
    const lstInputFiles = fileInfo.input_files
      ? JSON.parse(fileInfo.input_files)
      : [];
    this.state = {
      singleConsol: "single",
      scenario: "s1",
      isSelectAllInput: false,
      isSelectAllOutput: false,
      isSelectAlIntermediateOutput: false,
      fileInfo: fileInfo,
      lstInput: lstInputFiles.map((e) => ({
        input: e.name,
        upload_by: fileInfo.upload_by,
        upload_time: Business.convertToFullDate(fileInfo.upload_time),
      })),
      lstOutput: [],
      lstIntermediateOutput: [],
      failedDownloadsList: [],
      reportDate: Business.convertToDate(fileInfo.report_date),
      reportName: fileInfo.file_name || "",
      status: Business.convertFileStatus(fileInfo.status),
      reason: fileInfo.reason,
      loading: false,
      hasResult: false,
      showRejectAlert: false,
      showFileDownloadError: false,
      isDisableRejectButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableApprovalButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableReasonInput:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.WAITING_FOR_APPROVAL,
      isDisableCalculateButton:
        fileInfo.status !== Business.ENUMS.FILE_STATUS.APPROVED &&
        fileInfo.status !== Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
    };
  }

  listReportWillDelete = null;

  componentDidMount() {
    if (this.state.fileInfo.status === Business.ENUMS.FILE_STATUS.CALCULATED) {
      this.getReportList();
    }
  }

  getReportList = () => {
    Http.getListReport(
      Business.COMPONENT.ICAAP,
      this.state.fileInfo.file_name,
    ).then((data) => {
      const lstOutput = [];
      const lstIntermediateOutput = [];
      if (data && data.Success && data.Data) {
        data.Data.forEach((item) => {
          if (!Business.isOutputFile(item.report_name)) return;
          item.created = Business.convertToFullDate(item.created);
          if (Business.isIntermediateOutputFiles(item.report_name)) {
            lstIntermediateOutput.push(item);
          } else {
            lstOutput.push(item);
          }
        });
      }

      this.setState({
        lstOutput: lstOutput,
        lstIntermediateOutput: lstIntermediateOutput,
        loading: false,
      });
    });
  };

  onReject = () => {
    this.setState({ showRejectAlert: true });
  };

  onConfirmReject = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.ICAAP,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.REJECTED,
      this.state.reason,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.REJECTED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.REJECTED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onApproval = () => {
    Http.updateUploadInfo(
      Business.COMPONENT.ICAAP,
      this.state.reportDate,
      this.state.reportName,
      Business.ENUMS.FILE_STATUS.APPROVED,
      null,
    ).then((res) => {
      if (!res) {
        Business.showAlert({ title: "Error", content: "Unknow Error" });
      } else {
        if (res.Success) {
          Business.showAlert({ title: "Info", content: "Successfully" });
          this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.APPROVED);
          this.setState({
            status: Business.convertFileStatus(
              Business.ENUMS.FILE_STATUS.APPROVED,
            ),
          });
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: "Error",
                content: "You are not permission",
              });
            default:
              Business.showAlert({ title: "Error", content: "Unknow Error" });
          }
        }
      }
    });
    this.setState({ showRejectAlert: false });
  };

  onCalculate = () => {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATING);
    this.setState({
      loading: true,
      errorCode: ErrorCode.PendingBatchProcessing,
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATING,
      ),
    });
    Http.calculate(
      this.state.reportDate,
      this.state.reportName,
      this.state.singleConsol,
      this.state.scenario,
      true,
    ).then((res) => {
      this.setState({ loading: false });
      if (res && res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        this.onGetBatchResponse();
      } else {
        this.handleCalculateResponse(res);
      }
    });
  };

  onSelectInput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllInput === true) {
        this.setState({ isSelectAllInput: false });
        this.state.lstInput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllInput: true });
        this.state.lstInput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstInput.map((item) => {
        if (item.input === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAllOutput === true) {
        this.setState({ isSelectAllOutput: false });
        this.state.lstOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAllOutput: true });
        this.state.lstOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onSelectIntermediateOutput = (inputName) => {
    if (inputName === "SELECT_ALL") {
      if (this.state.isSelectAlIntermediateOutput === true) {
        this.setState({ isSelectAlIntermediateOutput: false });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = false;
        });
      } else {
        this.setState({ isSelectAlIntermediateOutput: true });
        this.state.lstIntermediateOutput.map((item) => {
          item.select = true;
        });
      }
    } else {
      this.state.lstIntermediateOutput.map((item) => {
        if (item.report_name === inputName) {
          if (item.select === true) {
            item.select = false;
          } else {
            item.select = true;
          }
        }
      });
    }
    this.forceUpdate();
  };

  onDownloadInputFiles = () => {
    const lstFileSelected = [];
    if (this.state.lstInput && this.state.lstInput.length > 0) {
      for (let i = 0; i < this.state.lstInput.length; i++) {
        const item = this.state.lstInput[i];
        if (item.select === true) {
          const fileInfo = Http.makeDownloadFileInfo(
            item.input,
            this.state.reportDate,
            this.state.reportName,
            "input_calculation",
            Business.COMPONENT.ICAAP,
          );
          lstFileSelected.push(fileInfo);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      Http.downloadAllFiles(
        lstFileSelected,
        this.state.fileInfo.report_date,
        this.state.fileInfo.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  onDownloadOutputFiles = () => {
    const lstFileSelected = [];
    if (this.state.lstOutput && this.state.lstOutput.length > 0) {
      for (let i = 0; i < this.state.lstOutput.length; i++) {
        const item = this.state.lstOutput[i];
        if (item.select === true) {
          const fileInfo = Http.makeDownloadFileInfo(
            item.report_name,
            this.state.reportDate,
            this.state.reportName,
            null,
            Business.COMPONENT.ICAAP,
          );
          lstFileSelected.push(fileInfo);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      Http.downloadAllFiles(
        lstFileSelected,
        this.state.fileInfo.report_date,
        this.state.fileInfo.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  onDownloadIntermediateOutputFiles = () => {
    const lstFileSelected = [];
    if (
      this.state.lstIntermediateOutput &&
      this.state.lstIntermediateOutput.length > 0
    ) {
      for (let i = 0; i < this.state.lstIntermediateOutput.length; i++) {
        const item = this.state.lstIntermediateOutput[i];
        if (item.select === true) {
          const fileInfo = Http.makeDownloadFileInfo(
            item.report_name,
            this.state.reportDate,
            this.state.reportName,
            null,
            Business.COMPONENT.ICAAP,
          );
          lstFileSelected.push(fileInfo);
        }
      }
    }

    if (lstFileSelected.length > 0) {
      Http.downloadAllFiles(
        lstFileSelected,
        this.state.fileInfo.report_date,
        this.state.fileInfo.file_name,
      ).then((result) => {
        if (result.is_error) {
          this.setState({
            showFileDownloadError: true,
            failedDownloadsList: result.failed_files,
          });
        }
      });
    }
  };

  onGetBatchResponse = () => {
    const intervalId = setInterval(() => {
      console.warn(`${this.state.reportName} | Request to get batch response`);
      Http.getBatchResult(this.state.reportDate, this.state.reportName).then(
        (res) => {
          this.handleGetBatchUploadingResponse(res);
        },
      );
    }, 3000);
    lstIntervalId.push(intervalId);
  };

  handleHideShowBtn(statusOfBatch) {
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.REJECTED) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
    if (
      statusOfBatch === Business.ENUMS.FILE_STATUS.APPROVED ||
      statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED
    ) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: false,
      });
    }
    if (statusOfBatch === Business.ENUMS.FILE_STATUS.CALCULATING) {
      this.setState({
        isDisableRejectButton: true,
        isDisableApprovalButton: true,
        isDisableReasonInput: true,
        isDisableCalculateButton: true,
      });
    }
  }

  handleErrorCode(res) {
    this.handleHideShowBtn(Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED);
    this.setState({
      status: Business.convertFileStatus(
        Business.ENUMS.FILE_STATUS.CALCULATION_STOPPED,
      ),
    });
    console.log(`Response: ${JSON.stringify(res || {})}`);
    if (res) {
      switch (res.ErrorCode) {
        case ErrorCode.PermissionDenie:
          Business.showAlert({
            title: "Error",
            content: "You are not permission",
          });
          break;
        case ErrorCode.Empty:
          Business.showAlert({ title: "Error", content: "File is empty" });
          break;
        case ErrorCode.Exist:
          Business.showAlert({
            title: "Error",
            content: "Name already exists in the system",
          });
          break;
        case ErrorCode.DataInvalid:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        case ErrorCode.UnknowError:
          Business.showAlert({
            title: "Error",
            content: res.Data || "System Error",
          });
          break;
        default:
          Business.showAlert({
            title: "Error",
            content: res.Data || "Unknow Error",
          });
          break;
      }
    } else {
      Business.showAlert({ title: "Error", content: "Unknow Error" });
    }
  }

  handleCalculateResponse = (res) => {
    const errorCode = res ? res.ErrorCode : null;
    this.setState({ errorCode });
    if (res && res.Success) {
      const data = res.Data || {};
      this.setState({
        hasResult: true,
        icaapConsolReport: data,
      });
    } else {
      this.handleErrorCode(res);
    }
  };

  handleGetBatchUploadingResponse = (res) => {
    if (res) {
      if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
        console.warn(
          `${this.state.reportName} | Received state: PendingBatchProcessing`,
        );
      } else {
        console.warn(`${this.state.reportName} | Received state: Success`);
        const errorCode = res ? res.ErrorCode : null;
        this.setState({ errorCode });
        if (res && res.ErrorCode !== ErrorCode.PendingBatchProcessing) {
          clearGetBatchResponseInterval(this.state.reportName);
        }
        if (res && res.Success) {
          if (res.ErrorCode === ErrorCode.PendingBatchProcessing) {
            // console.warn('Received state: PendingBatchProcessing');
          } else if (res.ErrorCode === ErrorCode.BatchEmpty) {
            clearGetBatchResponseInterval(this.state.reportName);
            console.warn("Received state: BatchEmpty");
          } else {
            const data = res.Data || {};
            this.getReportList();
            this.setState({
              hasResult: true,
              icaapConsolReport: data,
              status: Business.convertFileStatus(
                Business.ENUMS.FILE_STATUS.CALCULATED,
              ),
            });
          }
        } else {
          this.handleErrorCode(res);
        }
      }
    }
  };

  renderPendingBatchProcessing = () => {
    return (
      <div>
        <div className="header">
          <h4
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "50px",
              paddingTop: "50px",
            }}
            className="title"
          >
            The system is calculating. Please wait...
          </h4>
        </div>
      </div>
    );
  };

  renderResult = () => {
    const report = this.state.icaapConsolReport || DEFAULT_REPORT;
    return (
      <div>
        <div style={{ height: "100px" }} />
        <Table striped bordered hover>
          <thead>
            <tr>
              <td style={style.bolder} rowSpan={2}>
                TT
              </td>
              <td style={style.bolder} rowSpan={2}>
                Các khoản mục
              </td>
              <td style={style.bolder} rowSpan={2}>
                Đơn vị
              </td>
              <td style={style.bolder} colSpan={2}>
                Năm t0
              </td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>
                Năm t0+1
              </td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>
                Năm t0+2
              </td>
              {/* <td></td> */}
              <td style={style.bolder} colSpan={2}>
                Năm t0+3
              </td>
              {/* <td></td> */}
            </tr>
            <tr>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
              <td style={style.bolder}>BAU</td>
              <td style={style.bolder}>Stress</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={style.bolder}>I</td>
              <td style={style.bolder} colSpan={10}>
                Tài sản có rủi ro
              </td>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
            </tr>
            <tr>
              <td style={style.bolder}>1</td>
              <td style={style.bolder}>RWA*E</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t0)}</td>
              <td style={style.bolder}>
                {toAmountValue(report.rwa_e.stress_t0)}
              </td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t1)}</td>
              <td style={style.bolder}>
                {toAmountValue(report.rwa_e.stress_t1)}
              </td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t2)}</td>
              <td style={style.bolder}>
                {toAmountValue(report.rwa_e.stress_t2)}
              </td>
              <td style={style.bolder}>{toAmountValue(report.rwa_e.bau_t3)}</td>
              <td style={style.bolder}>
                {toAmountValue(report.rwa_e.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>1.1</td>
              <td>RWACR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_cr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_cr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_cr.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.2</td>
              <td>RWAOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_or.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_or.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_or.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.3</td>
              <td>RWAMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_mr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_mr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_mr.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.4</td>
              <td>RWACOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_cor.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_cor.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_cor.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.5</td>
              <td>RWAIRRBB</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_irrbb.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_irrbb.stress_t3)}</td>
            </tr>
            <tr>
              <td>1.6</td>
              <td>RWAOMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.rwa_omr.bau_t0)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t0)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t1)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t1)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t2)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t2)}</td>
              <td>{toAmountValue(report.rwa_omr.bau_t3)}</td>
              <td>{toAmountValue(report.rwa_omr.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>2</td>
              <td style={style.bolder}>∆RWA</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.bau_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.stress_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.bau_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.stress_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.bau_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.stress_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.bau_t3)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_rwa.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>2.1</td>
              <td>∆RWACR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_cr.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.2</td>
              <td>∆RWAOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_or.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_or.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.3</td>
              <td>∆RWAMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_mr.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.4</td>
              <td>∆RWACOR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_cor.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.5</td>
              <td>∆RWAIRRBB</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_irrbb.stress_t3)}</td>
            </tr>
            <tr>
              <td>2.6</td>
              <td>∆RWAOMR</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t0)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t1)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t2)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.bau_t3)}</td>
              <td>{toAmountValue(report.delta_rwa_omr.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>II</td>
              <td style={style.bolder} colSpan={10}>
                Đánh giá thay đổi về tỷ lệ an toàn vốn và các chỉ tiêu KVRR
              </td>
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
              {/* <td></td> */}
            </tr>
            <tr>
              <td style={style.bolder}>1</td>
              <td style={style.bolder}>Vốn tự có (CA)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.bau_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.stress_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.bau_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.stress_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.bau_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.stress_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.bau_t3)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_tu_co_ca.stress_t3)}
              </td>
            </tr>
            <tr>
              <td style={style.bolder}>2</td>
              <td style={style.bolder}>Vốn yêu cầu (CR)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.bau_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.stress_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.bau_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.stress_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.bau_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.stress_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.bau_t3)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_yeu_cau_cr.stress_t3)}
              </td>
            </tr>
            <tr>
              <td style={style.bolder}>3</td>
              <td style={style.bolder}>Vốn kinh tế (CE)</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.bau_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.stress_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.bau_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.stress_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.bau_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.stress_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.bau_t3)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.von_kinh_te_ce.stress_t3)}
              </td>
            </tr>
            <tr>
              <td></td>
              <td>Thuế suất</td>
              <td>%</td>
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t0)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t0)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t1)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t1)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t2)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t2)}</td> */}
              <td colSpan={2}>{toPercentValue(report.corp_tax.bau_t3)}</td>
              {/* <td>{toPercentValue(report.corp_tax.stress_t3)}</td> */}
            </tr>
            <tr>
              <td style={style.bolder}>4</td>
              <td style={style.bolder}>Δ PnL</td>
              <td style={style.bolder}>tỷ đồng</td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.bau_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.stress_t0)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.bau_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.stress_t1)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.bau_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.stress_t2)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.bau_t3)}
              </td>
              <td style={style.bolder}>
                {toAmountValue(report.delta_pnl.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>4.1</td>
              <td>Thay đổi thu nhập lãi</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t0)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t1)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t2)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.bau_t3)}</td>
              <td>{toAmountValue(report.thay_doi_thu_nhap_lai.stress_t3)}</td>
            </tr>
            <tr>
              <td>4.2</td>
              <td>Thay đổi chi phí dự phòng</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t0)}</td>
              <td>
                {toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t0)}
              </td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t1)}</td>
              <td>
                {toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t1)}
              </td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t2)}</td>
              <td>
                {toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t2)}
              </td>
              <td>{toAmountValue(report.thay_doi_chi_phi_du_phong.bau_t3)}</td>
              <td>
                {toAmountValue(report.thay_doi_chi_phi_du_phong.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>4.3</td>
              <td>Thay đổi thu nhập từ rủi ro thị trường</td>
              <td>tỷ đồng</td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t0,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t0,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t1,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t1,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t2,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t2,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.bau_t3,
                )}
              </td>
              <td>
                {toAmountValue(
                  report.thay_doi_thu_nhap_tu_rui_ro_thi_truong.stress_t3,
                )}
              </td>
            </tr>
            <tr>
              <td>4.4</td>
              <td>Tổn thất rủi ro hoạt động</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t0)}</td>
              <td>
                {toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t0)}
              </td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t1)}</td>
              <td>
                {toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t1)}
              </td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t2)}</td>
              <td>
                {toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t2)}
              </td>
              <td>{toAmountValue(report.ton_that_rui_ro_hoat_dong.bau_t3)}</td>
              <td>
                {toAmountValue(report.ton_that_rui_ro_hoat_dong.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>4.5</td>
              <td>Chi phí thanh khoản</td>
              <td>tỷ đồng</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t0)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t0)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t1)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t1)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t2)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t2)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.bau_t3)}</td>
              <td>{toAmountValue(report.chi_phi_thanh_khoan.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>5</td>
              <td style={style.bolder} colSpan={10}>
                Các tỷ lệ an toàn vốn
              </td>
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
              {/* <td style={style.bolder}></td> */}
            </tr>
            <tr>
              <td>5.1</td>
              <td>Tỷ lệ an toàn vốn (CAR)</td>
              <td>%</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_an_toan_von_car.stress_t3)}</td>
            </tr>
            <tr>
              <td>5.2</td>
              <td>Tỷ lệ an toàn vốn cấp 1 (CT1)</td>
              <td>%</td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t0)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t0)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t1)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t1)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t2)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t2)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.bau_t3)}
              </td>
              <td>
                {toPercentValue(report.ty_le_an_toan_von_cap_1_ct1.stress_t3)}
              </td>
            </tr>
            <tr>
              <td>5.3</td>
              <td>Tỷ lệ an toàn vốn chủ sở hữu cấp 1 (CET1)</td>
              <td>%</td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t0,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t0,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t1,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t1,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t2,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t2,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.bau_t3,
                )}
              </td>
              <td>
                {toPercentValue(
                  report.ty_le_an_toan_von_chu_so_huu_cap_1_cet1.stress_t3,
                )}
              </td>
            </tr>
            <tr>
              <td style={style.bolder}>6</td>
              <td style={style.bolder}>Tỷ lệ đòn bẩy</td>
              <td style={style.bolder}>%</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t0)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t0)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t1)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t1)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t2)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t2)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.bau_t3)}</td>
              <td>{toPercentValue(report.ty_le_don_bay.stress_t3)}</td>
            </tr>
            <tr>
              <td style={style.bolder}>7</td>
              <td style={style.bolder}>Các chỉ tiêu khẩu vị rủi ro khác</td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
              <td style={style.bolder}></td>
            </tr>
            <tr>
              <td>7.1</td>
              <td>ROE</td>
              <td>%</td>
              <td>{toPercentValue(report.roe.bau_t0)}</td>
              <td>{toPercentValue(report.roe.stress_t0)}</td>
              <td>{toPercentValue(report.roe.bau_t1)}</td>
              <td>{toPercentValue(report.roe.stress_t1)}</td>
              <td>{toPercentValue(report.roe.bau_t2)}</td>
              <td>{toPercentValue(report.roe.stress_t2)}</td>
              <td>{toPercentValue(report.roe.bau_t3)}</td>
              <td>{toPercentValue(report.roe.stress_t3)}</td>
            </tr>
            <tr>
              <td>7.2</td>
              <td>RAROC</td>
              <td>%</td>
              <td>{toPercentValue(report.raroc.bau_t0)}</td>
              <td>{toPercentValue(report.raroc.stress_t0)}</td>
              <td>{toPercentValue(report.raroc.bau_t1)}</td>
              <td>{toPercentValue(report.raroc.stress_t1)}</td>
              <td>{toPercentValue(report.raroc.bau_t2)}</td>
              <td>{toPercentValue(report.raroc.stress_t2)}</td>
              <td>{toPercentValue(report.raroc.bau_t3)}</td>
              <td>{toPercentValue(report.raroc.stress_t3)}</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  };

  handleSelectSingleConsolMethod = (eventKey, event) => {
    this.setState({ singleConsol: eventKey });
  };

  handleSelectScenario = (eventKey, event) => {
    this.setState({ scenario: eventKey });
  };

  renderInputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadInputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectInput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Input</th>
                <th>Uploader</th>
                <th>Upload Time</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstInput.map((item, index) => (
                <tr key={item.input}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.input}`}
                        onChange={() => this.onSelectInput(item.input)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.input}</td>
                  <td>{item.upload_by}</td>
                  <td>{item.upload_time}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderOutputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadOutputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() => this.onSelectOutput("SELECT_ALL")}
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() => this.onSelectOutput(item.report_name)}
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderIntermediateOutputFileManagement = () => {
    return (
      <div>
        <div style={{ fontWeight: 500, marginBottom: "10px" }}>
          <a
            rel="tooltip"
            aria-disabled="true"
            className="btn btn-info btn-simple btn-xs"
            data-original-title="View Profile"
            onClick={() => {
              this.onDownloadIntermediateOutputFiles();
            }}
          >
            <i
              style={{ fontSize: 23, color: "red" }}
              className="pe-7s-download"
            ></i>
          </a>
          <span>Download selected files</span>
        </div>
        <div
          style={{
            position: "relative",
            height: "300px",
            overflowY: "scroll",
            marginBottom: "30px",
          }}
        >
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkAllToDownload"
                      onChange={() =>
                        this.onSelectIntermediateOutput("SELECT_ALL")
                      }
                      checked={this.state.isSelectAll === true}
                    />
                  </div>
                </th>
                <th>No.</th>
                <th>Intermediate Output</th>
                <th>CreatedTime</th>
              </tr>
            </thead>
            <tbody>
              {this.state.lstIntermediateOutput.map((item, index) => (
                <tr key={item.report_name}>
                  <td>
                    <div className="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id={`checkToDownload_${item.report_name}`}
                        onChange={() =>
                          this.onSelectIntermediateOutput(item.report_name)
                        }
                        checked={item.select === true}
                      />
                    </div>
                  </td>
                  <td>{index + 1}</td>
                  <td style={{ color: "blue" }}>{item.report_name}</td>
                  <td>{item.created}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    if (this.state.loading)
      return (
        <div style={{ height: Business.getHeightContent() }}>
          <Loading size="small" />
        </div>
      );

    return (
      <div className="card">
        <div className="header">
          <h4 className="title">{`${this.state.reportDate || ""} # ${`${this.state.reportName || ""}`.substring("ICAAP_".length)} # ${this.state.status || ""}`}</h4>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div className="form-group">
              <div className="ey-tag-selector">
                <label className="ey-tag-label">Single Consol:</label>
                <div className="ey-tag-group">
                  {Object.entries(dicSingleConsol).map(([key, label]) => (
                    <button
                      key={key}
                      type="button"
                      className={
                        "ey-tag" +
                        (this.state.singleConsol === key
                          ? " ey-tag--active"
                          : "")
                      }
                      onClick={() => this.setState({ singleConsol: key })}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="ey-tag-selector">
                <label className="ey-tag-label">Scenario:</label>
                <div className="ey-tag-group">
                  {Object.entries(dicScenario).map(([key, label]) => (
                    <button
                      key={key}
                      type="button"
                      className={
                        "ey-tag" +
                        (this.state.scenario === key ? " ey-tag--active" : "")
                      }
                      onClick={() => this.setState({ scenario: key })}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {this.renderInputFileManagement()}

          {(this.state.fileInfo.status ===
            Business.ENUMS.FILE_STATUS.CALCULATED ||
            this.state.lstOutput.length > 0) &&
            this.renderOutputFileManagement()}

          {(this.state.fileInfo.status ===
            Business.ENUMS.FILE_STATUS.CALCULATED ||
            this.state.lstIntermediateOutput.length > 0) &&
            this.renderIntermediateOutputFileManagement()}

          {console.log(
            `${this.state.reportName} | file info status: ${this.state.fileInfo.status} | lst output length: ${this.state.lstOutput.length} | lst intermediate output length: ${this.state.lstIntermediateOutput.length}`,
          )}

          <div>
            <FormGroup controlId="formControlsTextarea">
              <label htmlFor="exampleInputEmail1">Reason for rejection: </label>
              <FormControl
                style={{ height: "100px", resize: "none" }}
                disabled={this.state.isDisableReasonInput}
                componentClass="textarea"
                value={this.state.reason}
                placeholder="Type your reason here..."
                onChange={(event) => {
                  this.setState({ reason: event.target.value });
                }}
              />
            </FormGroup>
            <div style={{ display: "inline" }}>
              <button
                type="button"
                disabled={
                  this.state.progressValue > 0 ||
                  this.state.isDisableRejectButton
                }
                className="btn btn-primary"
                style={{
                  backgroundColor: "rgb(255 0 0)",
                  borderColor: "rgb(255 255 255)",
                  borderRadius: "5px",
                  fontWeight: 600,
                  marginLeft: "auto",
                  float: "left",
                  color: "white",
                }}
                onClick={() => {
                  this.onReject();
                }}
              >
                Reject
              </button>
              <div style={{ display: "flex", float: "right" }}>
                <button
                  type="button"
                  disabled={
                    this.state.progressValue > 0 ||
                    this.state.isDisableApprovalButton ||
                    !Business.isHasRole([
                      Business.ROLE_DEFINE_MAP.ICAAP_APPROVAL_FILES,
                    ])
                  }
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#FFE600",
                    borderColor: "#7F7E82",
                    borderRadius: "5px 0px 0px 5px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    this.onApproval();
                  }}
                >
                  Approval
                </button>
                <button
                  type="button"
                  disabled={
                    this.state.progressValue > 0 ||
                    this.state.isDisableCalculateButton ||
                    !Business.isHasRole([
                      Business.ROLE_DEFINE_MAP.ICAAP_CALCULATE,
                    ])
                  }
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "rgb(0 255 90)",
                    borderColor: "#7F7E82",
                    borderRadius: "0px 5px 5px 0px",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    this.onCalculate();
                  }}
                >
                  Calculate
                </button>
              </div>
            </div>
          </div>
          {this.state.errorCode === ErrorCode.PendingBatchProcessing &&
            this.renderPendingBatchProcessing()}
          {this.state.hasResult && this.renderResult()}
        </div>
        <Alert
          title="Are you sure?"
          text="You will not be able to undo!"
          show={this.state.showRejectAlert}
          showCancelButton
          onConfirm={() => {
            this.onConfirmReject();
          }}
          onCancel={() => {
            this.setState({ showRejectAlert: false });
          }}
        />
        <Alert
          title="Some files failed to download!"
          text={`Please check the following files: ${this.state.failedDownloadsList.join(", ")}`}
          show={this.state.showFileDownloadError}
          onConfirm={() => {
            this.setState({ showFileDownloadError: false });
          }}
        />
      </div>
    );
  }
}

const style = {
  bolder: {
    fontWeight: 600,
  },
};

const lstIntervalId = [];
function clearGetBatchResponseInterval(reportName) {
  lstIntervalId.forEach((intervalId) => clearInterval(intervalId));
  console.warn(`${reportName} | Received state: STOP`);
}

function toPercentValue(value) {
  if (!value || value === 0) return "";
  return `${(value * 100).toLocaleString("en-GB")}%`;
}

function toAmountValue(value) {
  if (!value || value === 0) return "";
  return `${value.toLocaleString("en-GB")}`;
}

const DEFAULT_REPORT = {
  rwa_e: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //delta
  delta_rwa: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_or: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_mr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_cor: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_irrbb: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  delta_rwa_omr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von tu co
  von_tu_co_ca: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von yeu cau
  von_yeu_cau_cr: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Von kinh te
  von_kinh_te_ce: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Thue suat
  corp_tax: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  //Delta PNL
  delta_pnl: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_lai: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_chi_phi_du_phong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  thay_doi_thu_nhap_tu_rui_ro_thi_truong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ton_that_rui_ro_hoat_dong: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  chi_phi_thanh_khoan: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_car: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_cap_1_ct1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_an_toan_von_chu_so_huu_cap_1_cet1: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  ty_le_don_bay: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  roe: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
  raroc: {
    bau_t0: 0,
    stress_t0: 0,
    bau_t1: 0,
    stress_t1: 0,
    bau_t2: 0,
    stress_t2: 0,
    bau_t3: 0,
    stress_t3: 0,
  },
};

export default FileInfo;



// WEBPACK FOOTER //
// src/pages/ICAAP/FileManagement/FileInfo.js